import { render, staticRenderFns } from "./urlLink.vue?vue&type=template&id=cd885f26&scoped=true&"
import script from "./urlLink.vue?vue&type=script&lang=js&"
export * from "./urlLink.vue?vue&type=script&lang=js&"
import style0 from "./urlLink.vue?vue&type=style&index=0&id=cd885f26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd885f26",
  null
  
)

export default component.exports